import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// report-common
import { getReportReducers } from '../../report-common';
// helpers/constants
import * as G from '../../helpers';
// feature average-fuel-price
import * as A from './actions';
//////////////////////////////////////////////////

const listState = {
  itemList: [],
  totalCount: 0,
  titleSortValues: {},
  tableTitleFilters: {},
};

const initial = {
  weekly: listState,
  monthly: listState,
  activeTab: 'weekly',
};

const {
  initialState,
  setListLoading,
  setInitialState,
  setReportPending,
} = getReportReducers(initial);

const setActiveTab = (state, data) => P.$set('activeTab', data, state);

const resetListAndPagination = (state) => {
  const { activeTab } = state;

  return P.$all(
    P.$set('pagination.offset', 0),
    P.$set(`${activeTab}.itemList`, []),
    state,
  );
};

const setTableTitleSort = (state, data) => {
  const { activeTab } = state;

  const titleSortValues = R.path([activeTab, 'titleSortValues'], state);
  const sortValues = G.getTableTitleSortValues(titleSortValues, data);

  return P.$set(`${activeTab}.titleSortValues`, sortValues, state);
};

const setTableTitleFilter = (state, data) => {
  const { activeTab } = state;

  const titleFilterValues = R.path([activeTab, 'tableTitleFilters'], state);
  const filterValues = G.getTableTitleFilterValues(titleFilterValues, data);

  return P.$set(`${activeTab}.tableTitleFilters`, filterValues, state);
};

const getItemListSuccess = (state, data) => {
  const { results, totalCount } = data;

  const { activeTab, pagination } = state;

  const itemList = R.pathOr({}, [activeTab, 'itemList'], state);

  const newOffset = R.sum(R.values(pagination));

  const offsetToUse = G.ifElse(
    R.gt(totalCount, newOffset),
    newOffset,
    totalCount,
  );

  const list = R.concat(R.or(itemList, []), results);

  return P.$all(
    P.$set(`${activeTab}.itemList`, list),
    P.$set('pagination.offset', offsetToUse),
    P.$set(`${activeTab}.totalCount`, totalCount),
    state,
  );
};

export default createReducer({
  [A.setActiveTab]: setActiveTab,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
}, initialState);

